module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GB-b11df98a430b1c5b329bfc07988651a1.png";